/**
 *
 */
import { get, post ,del,put,upload,downloadImg,downloadTemplate} from 'mdoc/admin/axios/tools'
import * as config from 'mdoc/admin/axios/config'

//コンテンツ一覧API
export const getContentSearch = (param) => new Promise((resolve, reject)=> {
    get(config.CONTENTS, param)
        .then(function (response) {
            // if (response.error) {
            //     reject(response.errorMessage);
            // } else {
                resolve({results: response.docTblBookList, count: response.count})
            // }
        }).catch(function (error) {
        reject(error);
    })
})
//カテゴリ所属の親カテゴリ情報を取得
export const getParentId = (param) => new Promise((resolve, reject)=> {
    get(config.SEARCH_PARTENTSID,param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response.docMstBookCategoryList, count: response.count})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//コンテンツ一覧削除
export const contentDelete = (id,param) => new Promise((resolve, reject)=> {
    del(config.CONTENTS+'/'+id, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//コンテンツ詳細API
export const contentDetail = (id,param) => new Promise((resolve, reject)=> {
    get(config.CONTENTS+'/'+id, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//コンテンツ登録API
export const contentLogin = (param) => new Promise((resolve, reject)=> {
    post(config.CONTENTS, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//コンテンツ更新API
export const contentUpload = (param) => new Promise((resolve, reject)=> {
    put(config.CONTENTS, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
            reject(error);
    })
})

//コンテンツ img upload
export const contentImgUpload = (param) => new Promise((resolve, reject)=> {
    upload(config.CONTENT_IMG_UPLOAD, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
            reject(error);
    })
})
//コンテンツ img upload
export const contentBookImg = (bookId,param={}) => new Promise((resolve, reject)=> {
    get(config.BOOK_EDIT_IMG+'/'+bookId, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
        reject(error);
    })
})
//コンテンツ file upload
export const contentContentUpload = (param) => new Promise((resolve, reject)=> {
    upload(config.CONTENT_CONTENT_UPLOAD, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
            reject(error);
    })
})
//コンテンツ一括登録uploads
export const contentMultipleUpload = (folderUuid,param) => new Promise((resolve, reject)=> {
    upload(config.CONTENT_UPLOADS+folderUuid, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
        reject(error);
    })
})
////コンテンツ一括登録files
export const contentUploadFile = (folderUuid,param) => new Promise((resolve, reject)=> {
    upload(config.CONTENT_UPLOAD+folderUuid, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
        reject(error);
    })
})
//画像のpath
export const getImagePath = (folderUuid,fileUuid) => new Promise((resolve, reject)=> {
    downloadImg(config.IMG_PATH+'/'+folderUuid+'/'+fileUuid)
        .then(res => {
            return 'data:image/png;base64,' + btoa(
                new Uint8Array(res).reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
        })
        .then(data => {
            resolve(data);
        }).catch(function (error) {
        reject(error);
    })
})

//get BigImage
export const getBigImage = (folderUuid,fileUuid) => new Promise((resolve, reject)=> {
    downloadImg(config.DOWNLOAD_BIGIMAGE+'/'+folderUuid+'/'+fileUuid)
        .then(res => {
            return 'data:image/png;base64,' + btoa(
                new Uint8Array(res).reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
        })
        .then(data => {
            resolve(data);
        }).catch(function (error) {
        reject(error);
    })
})

//Download Bigimage PDF
export const downloadBigimagePDF = (categoryId,folderUuid, fileUuid) => new Promise((resolve, reject) => {
    downloadImg(config.DOWNLOAD_BIGIMAGE_PDF + '/' + categoryId+ '/' + folderUuid + '/' + fileUuid)
        .then(res => {
            var blob = new Blob([res], { type: 'application/pdf;charset=utf-8' });
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob,fileUuid);
            } else {
                var downloadElement = document.createElement('a');
                var href = window.URL.createObjectURL(blob);
                downloadElement.href = href;
                downloadElement.download =fileUuid;
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
            }
        })
        .then(data => {
            resolve(data);
        }).catch(function (error) {
            reject(error);
        })
})

// コンテンツ一括登録Download
export const getFilePath = (name,param) => new Promise((resolve, reject)=> {
    downloadTemplate(config.CONTENT_DOWNLOAD, param)
        .then(res => {
            var blob = new Blob([res], {type: 'application/vnd.ms-excel;charset=utf-8'});
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob,name);
            }else{
                var downloadElement = document.createElement('a');
                var href = window.URL.createObjectURL(blob);
                downloadElement.href = href;
                downloadElement.download = name;
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
            }
        })
        .then(data => {
            resolve(data);
        }).catch(function (error) {
        reject(error);
    })
})
// コンテンツ一括登録カテゴリーコードの存在チェックAPI
export const contentCheck = (param) => new Promise((resolve, reject)=> {
    post(config.CONTENT_CHECK, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})

// コンテンツのファイルをクリア flag=>0:book,1:image
export const contentFileClear = (folderUuid,flag,param) => new Promise((resolve, reject)=> {
    get(config.CONTENTS+'/'+folderUuid+'/'+flag, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
        reject(error);
    })
})
////ファイル upload
export const contentAddUpload = (applyId,param) => new Promise((resolve, reject)=> {
    upload(config.CONTENT_ADD_UPLOAD+applyId, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
        reject(error);
    })
})

export const contentAddUploadFile = (param) => new Promise((resolve, reject)=> {
    post(config.CONTENT_ADD, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response);
            }
        }).catch(function (error) {
        reject(error);
    })
})
// 申請書フォーマットDownload
export const applicationFormatDownload = (name,param) => new Promise((resolve, reject)=> {
    downloadTemplate(config.APPLICATION_DOWNLOAD, param)
        .then(res => {
            var blob = new Blob([res], {type: 'application/vnd.ms-excel;charset=utf-8'});
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob,name);
            }else{
                var downloadElement = document.createElement('a');
                var href = window.URL.createObjectURL(blob);
                downloadElement.href = href;
                downloadElement.download = name;
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
            }
        })
        .then(data => {
            resolve(data);
        }).catch(function (error) {
        reject(error);
    })
})

//申請書取込
export const applyUpload = (param) => new Promise((resolve, reject)=> {
    upload(config.APPLY_UPLOAD, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
        reject(error);
    })
})

//申請書一覧

export const applyList = (param) => new Promise((resolve, reject)=> {
    get(config.CONTENT_READ, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response.docTblApplyList, count: response.count})
            }
        }).catch(function (error) {
        reject(error);
    })
})

export const userList = (param) => new Promise((resolve, reject)=> {
    get(config.CONTENT_DETAIL, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response, count: response.count})
            }
        }).catch(function (error) {
        reject(error);
    })
})

// 申請書ユーザーの保存
export const contentSaveApplyUser = (param) => new Promise((resolve, reject)=> {
    post(config.APPLY_SAVE_APPLY_USER, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
        reject(error);
    })
})

// 申請書ユーザーの保存
export const contentDeleteApplyUser = (param) => new Promise((resolve, reject)=> {
    post(config.APPLY_DELETE_APPLY_USER, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
        reject(error);
    })
})

// 申請書ユーザーの
export const contentApplyUserList = (param) => new Promise((resolve, reject)=> {
    get(config.CONTENT_DETAIL, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
        reject(error);
    })
})

//申請書部署ユーザCSV出力
export const downloadUserCSV = (param) => new Promise((resolve, reject) => {
    let {csvName}=param;
    downloadTemplate(config.DOWNLOAD_APPLY_USER_CSV, param)
        .then(res => {
            var blob = new Blob([res], { type: 'text/plain;charset=utf-8' });
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, csvName + '.csv');
            } else {
                var downloadElement = document.createElement('a');
                var href = window.URL.createObjectURL(blob);
                downloadElement.href = href;
                downloadElement.download = csvName + '.csv';
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
            }
        })
        .then(data => {
            resolve(data);
        }).catch(function (error) {
            reject(error);
        })
})

//申請書部署ユーザCSV取込
export const UpLoadUserCSV = (applyId,data) => new Promise((resolve, reject) => {
    upload(config.UPLOAD_APPLY_USER_CSV+'/'+applyId,data)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
            reject(error);
    })
})

export const contentUploadFiles = (applyId) => new Promise((resolve, reject)=> {
    get(config.CONTENT_UPLOAD_FILES+'/'+applyId)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
        reject(error);
    })
})

//コンテンツ追加
export const contentUploadDelete = (id) => new Promise((resolve, reject)=> {
    del(config.CONTENT_UPLOAD_DELETE+'/'+id)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
        reject(error);
    })
})